import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa4b04b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "studentEdit" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { class: "btn-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "学生上课记录", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("      ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("复制模板")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 识别 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("   至   ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" (单位：分钟) ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 修改 ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 新建 ")
const _hoisted_15 = { class: "right" }
const _hoisted_16 = { class: "btn-box" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "研究生上课记录", -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode("      ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("复制模板")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 识别 ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("   至   ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" (单位：分钟) ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 修改 ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 新建 ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Ctrl+A全部选中，Ctrl+C复制，Ctrl+V粘贴")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Ctrl+A全部选中，Ctrl+C复制，Ctrl+V粘贴")

import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  createStudentRecord,
  createPostgraRecord,
	updateStudentRecord,
	updatePostgraRecord,
	getRecordList,
	stuDistinguish,
	posDistinguish
} from "../../config/interface";
import type { ElForm } from "element-plus";
import { ElMessage } from "element-plus";
type FormInstance = InstanceType<typeof ElForm>;


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const temp = "上课时间：\n结束时间：\n本课知识点：\n课程感受：\n上次课后作业完成情况：\n其他疑问点：\n对研究生评价：";
const temp2 = "上课时间：\n结束时间：\n本课辅导内容：\n课后作业布置：\n对学生的评价："
const ruleFormRef = ref<FormInstance>();
const ruleFormRef2 = ref<FormInstance>();
let back = "<";
let flag = ref(0);
let flag2 = ref(0);
const btnLoading = ref(false);
const btnLoading2 = ref(false);
const stuQuickCont = ref("");
const postQuickCont = ref("")
const router = useRouter();
const route = useRoute();
const dialogVisible = ref(false);
const dialogVisible2 = ref(false);
// 学生上课记录信息
let studentRecord = ref({
	id: "",
  startTime: "",
  endTime: "",
  duration: "",
  point: "",
  feel: "",
  work: "",
  others: "",
  evaluation: "",
});
// 研究生上课记录信息
let postgraRecord = ref({
	id: "",
  startTime: "",
  endTime: "",
  duration: "",
  point: "",
  work: "",
  evaluation: "",
});
const rules = {
  startTime: [
    {
      required: true,
      message: "请输入学习时间",
      trigger: "blur",
    },
  ],
  duration: [
    {
      required: true,
      message: "请输入学习时长",
      trigger: "blur",
    },
  ],
};
const rules2 = {
  startTime: [
    {
      required: true,
      message: "请输入学习时间",
      trigger: "blur",
    },
  ],
  duration: [
    {
      required: true,
      message: "请输入学习时长",
      trigger: "blur",
    },
  ],
};

const handleCopyStudentTemp = () => {
	dialogVisible.value = true;
}
const handleCopyPostgraTemp = () => {
	dialogVisible2.value = true;
}

const handleChangeStartTime = (val: any) => {
  if (val) {
    console.log(val);
  } else {
    return;
  }
};
const handleChangeEndTime = (val: any) => {
  if (val) {
    console.log(val);
  } else {
    return;
  }
};

// 提交表单，请求新增学生记录接口
const handleCreateStudent = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      console.log(studentRecord.value);
      let params = {
        crId: route.query.crId,
        startTime: studentRecord.value.startTime,
        endTime: studentRecord.value.endTime,
        classDuration: studentRecord.value.duration,
        classUnit: 1,
        classKnowledge: studentRecord.value.point,
        classFeeling: studentRecord.value.feel,
        homeworkCompletion: studentRecord.value.work,
        question: studentRecord.value.others,
        evaluate: studentRecord.value.evaluation,
      };
      createStudentRecord(params).then((res) => {
        if (res.data.data && res.data.success) {
          ElMessage.success(res.data.data);
					window.location.reload();
        } else {
          ElMessage.error(res.data.msg);
        }
      });
    } else {
      console.log("error submit!");
      return false;
    }
  });
};
// 提交表单，请求编辑学生记录接口
const handleEditStudent = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      console.log(studentRecord.value);
      let params = {
				id: studentRecord.value.id,
        crId: route.query.crId,
        startTime: studentRecord.value.startTime,
        endTime: studentRecord.value.endTime,
        classDuration: studentRecord.value.duration,
        classUnit: 1,
        classKnowledge: studentRecord.value.point,
        classFeeling: studentRecord.value.feel,
        homeworkCompletion: studentRecord.value.work,
        question: studentRecord.value.others,
        evaluate: studentRecord.value.evaluation,
      };
      updateStudentRecord(params).then((res) => {
        if (res.data.data && res.data.success) {
          ElMessage.success(res.data.data);
					window.location.reload();
        } else {
          ElMessage.error(res.data.msg);
        }
      });
    } else {
      console.log("error submit!");
      return false;
    }
  });
};
// 提交表单，请求新增研究生记录接口
const handleCreatePostgra = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      let params = {
        crId: route.query.crId,
        startTime: postgraRecord.value.startTime,
        endTime: postgraRecord.value.endTime,
        classDuration: postgraRecord.value.duration,
        classUnit: 1,
        coachContent: postgraRecord.value.point,
        homework: postgraRecord.value.work,
        evaluate: postgraRecord.value.evaluation,
      };
      createPostgraRecord(params).then((res) => {
        if (res.data.data && res.data.success) {
          ElMessage.success(res.data.data);
					window.location.reload();
        } else {
          ElMessage.error(res.data.msg);
        }
      });
    } else {
      console.log("error submit!");
      return false;
    }
  });
};
// 提交表单，请求编辑研究生记录接口
const handleEditPostgra = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      let params = {
				id: postgraRecord.value.id,
        crId: route.query.crId,
        startTime: postgraRecord.value.startTime,
        endTime: postgraRecord.value.endTime,
        classDuration: postgraRecord.value.duration,
        classUnit: 1,
        coachContent: postgraRecord.value.point,
        homework: postgraRecord.value.work,
        evaluate: postgraRecord.value.evaluation,
      };
      updatePostgraRecord(params).then((res) => {
        if (res.data.data && res.data.success) {
          ElMessage.success(res.data.data);
					window.location.reload();
        } else {
          ElMessage.error(res.data.msg);
        }
      });
    } else {
      console.log("error submit!");
      return false;
    }
  });
};
// 新建学生上课记录--快速识别
const handleStudentDist = () => {
	let params = {
		posRecord: stuQuickCont.value
	}
	stuDistinguish(params).then((res)=>{
		let value = res.data.data;
		studentRecord.value.startTime = value.startTime;
		studentRecord.value.endTime = value.endTime;
		studentRecord.value.point = value.classKnowledge;
		studentRecord.value.feel = value.classFeeling;
		studentRecord.value.work = value.homeworkCompletion;
		studentRecord.value.others = value.question;
		studentRecord.value.evaluation = value.evaluate;
	})
}
// 新建研究上课记录--快速识别
const handlePostgraDist = () => {
	let params = {
		posRecord: postQuickCont.value
	}
	posDistinguish(params).then((res)=>{
		let value = res.data.data;
		postgraRecord.value.point = value.coachContent;
		postgraRecord.value.work = value.homework;
		postgraRecord.value.evaluation = value.evaluate;
	})
}

const handleBack = () => {
	// router.push({
	// 	path: '/order'
	// })
	router.back()
};

onMounted(() => {
	getRecordList({crId: route.query.crId}).then((res)=>{
		if(res.data.data && res.data.success) {
			if(res.data.data.stuRecord) {
				let value = res.data.data.stuRecord;
				studentRecord.value.id = value.id;
				studentRecord.value.startTime = value.startTime;
				studentRecord.value.endTime = value.endTime;
				studentRecord.value.duration = value.classDuration;
				studentRecord.value.point = value.classKnowledge;
				studentRecord.value.feel = value.classFeeling;
				studentRecord.value.work = value.homeworkCompletion;
				studentRecord.value.others = value.question;
				studentRecord.value.evaluation = value.evaluate;
				flag.value = 1;
			}
			if(res.data.data.posRecord) {
				let value2 = res.data.data.posRecord;
				postgraRecord.value.id = value2.id;
				postgraRecord.value.startTime = value2.startTime;
				postgraRecord.value.endTime = value2.endTime;
				postgraRecord.value.duration = value2.classDuration;
				postgraRecord.value.point = value2.coachContent;
				postgraRecord.value.work = value2.homework;
				postgraRecord.value.evaluation = value2.evaluate;
				flag2.value = 1;
			}
		} else {
			ElMessage.error(res.data.msg)
		}
	})

});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "back",
        onClick: handleBack
      }, _toDisplayString(_unref(back)) + " 返回", 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createVNode(_component_el_button, {
            type: "text",
            onClick: handleCopyStudentTemp
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          rules: rules,
          model: _unref(studentRecord),
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            (!_unref(flag))
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "智能识别"
                }, {
                  default: _withCtx(() => [
                    (!_unref(flag))
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 0,
                          modelValue: stuQuickCont.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((stuQuickCont).value = $event)),
                          type: "textarea",
                          autosize: "",
                          style: {"width":"350px"},
                          placeholder: "可粘贴信息，系统智能识别"
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      style: {"width":"80px","margin-left":"10px"},
                      loading: btnLoading.value,
                      onClick: handleStudentDist
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "上课时间",
              prop: "startTime"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _unref(studentRecord).startTime,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(studentRecord).startTime) = $event)),
                  type: "datetime",
                  onChange: handleChangeStartTime
                }, null, 8, ["modelValue"]),
                _hoisted_10,
                _createVNode(_component_el_date_picker, {
                  modelValue: _unref(studentRecord).endTime,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(studentRecord).endTime) = $event)),
                  type: "datetime",
                  onChange: handleChangeEndTime
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "上课时长",
              prop: "duration"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(studentRecord).duration,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(studentRecord).duration) = $event)),
                  placeholder: "请输入上课时长",
                  style: {"width":"220px"}
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  type: "text",
                  size: "small",
                  style: {"margin-left":"10px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "本课知识点" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(studentRecord).point,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(studentRecord).point) = $event)),
                  type: "textarea",
                  autosize: "",
                  style: {"width":"350px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "课程感受" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(studentRecord).feel,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(studentRecord).feel) = $event)),
                  type: "textarea",
                  autosize: "",
                  style: {"width":"350px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "作业完成情况" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(studentRecord).work,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(studentRecord).work) = $event)),
                  type: "textarea",
                  autosize: "",
                  style: {"width":"350px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "其他疑问点" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(studentRecord).others,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(studentRecord).others) = $event)),
                  type: "textarea",
                  autosize: "",
                  style: {"width":"350px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "评价" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(studentRecord).evaluation,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(studentRecord).evaluation) = $event)),
                  type: "textarea",
                  autosize: "",
                  style: {"width":"350px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (dialogVisible.value = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                (_unref(flag))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (handleEditStudent(ruleFormRef.value)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "primary",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (handleCreateStudent(ruleFormRef.value)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _hoisted_18,
          _createVNode(_component_el_button, {
            type: "text",
            onClick: handleCopyPostgraTemp
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef2",
          ref: ruleFormRef2,
          rules: rules2,
          model: _unref(postgraRecord),
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            (!_unref(flag2))
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "智能识别"
                }, {
                  default: _withCtx(() => [
                    (!_unref(flag2))
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 0,
                          modelValue: postQuickCont.value,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((postQuickCont).value = $event)),
                          type: "textarea",
                          autosize: "",
                          style: {"width":"350px"},
                          placeholder: "可粘贴信息，系统智能识别"
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      style: {"width":"80px","margin-left":"10px"},
                      loading: btnLoading2.value,
                      onClick: handlePostgraDist
                    }, {
                      default: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "上课时间",
              prop: "startTime",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _unref(postgraRecord).startTime,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(postgraRecord).startTime) = $event)),
                  type: "datetime"
                }, null, 8, ["modelValue"]),
                _hoisted_21,
                _createVNode(_component_el_date_picker, {
                  modelValue: _unref(postgraRecord).endTime,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(postgraRecord).endTime) = $event)),
                  type: "datetime"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "上课时长",
              prop: "duration"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(postgraRecord).duration,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(postgraRecord).duration) = $event)),
                  placeholder: "请输入上课时长",
                  style: {"width":"220px"}
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  type: "text",
                  size: "small",
                  style: {"margin-left":"10px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "辅导内容" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(postgraRecord).point,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(postgraRecord).point) = $event)),
                  type: "textarea",
                  autosize: "",
                  style: {"width":"350px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "作业布置" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(postgraRecord).work,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(postgraRecord).work) = $event)),
                  type: "textarea",
                  autosize: "",
                  style: {"width":"350px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "评价" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(postgraRecord).evaluation,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(postgraRecord).evaluation) = $event)),
                  type: "textarea",
                  autosize: "",
                  style: {"width":"350px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (dialogVisible.value = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 1
                }),
                (_unref(flag2))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (handleEditPostgra(ruleFormRef2.value)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_24
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "primary",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (handleCreatePostgra(ruleFormRef2.value)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_25
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((dialogVisible).value = $event)),
      title: "学生上课记录模板",
      width: "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: temp,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((temp) = $event)),
          type: "textarea",
          autosize: ""
        }),
        _createVNode(_component_el_button, { type: "text" }, {
          default: _withCtx(() => [
            _hoisted_26
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible2.value,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((dialogVisible2).value = $event)),
      title: "研究生信息录入模板",
      width: "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: temp2,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((temp2) = $event)),
          type: "textarea",
          autosize: ""
        }),
        _createVNode(_component_el_button, { type: "text" }, {
          default: _withCtx(() => [
            _hoisted_27
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})